module.exports = __webpack_public_path__ + "static/media/glyphicons-halflings-regular.fa277232.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.woff
 ** module id = 1598
 ** module chunks = 0
 **/